<template>
  <main>
    <SectionHero :variant="hero.variant" class="franchise-hero">
      <OrganismHero :hero="hero" class="franchise-hero__content" />
      <template #footerShort>
        <div class="flex w-full flex-1 items-end justify-end md:w-auto">
          <InsightWidget
            to="#contacts"
            :title="contactWidget.title"
            src="franchise/franchise-widget.webp"
            card-class="border-white bg-gray-600 hover:border-white hover:bg-gray-600"
            arrow-direction="down"
            class="h-[87px] w-full md:h-[104px] md:w-80"
          />
        </div>
      </template>
    </SectionHero>
    <SectionDefault class="franchise-page">
      <Builder :blocks="blocks" />
    </SectionDefault>
  </main>
</template>

<script>
import Builder from '../components/builder/Builder'
import pageBuilder from '../components/mixins/pageBuilder.js'
import InsightWidget from '../components/molecules/InsightWidget.vue'
import OrganismHero from '../components/organisms/layouts/OrganismHero'
import SectionDefault from '../components/templates/layouts/SectionDefault'
import SectionHero from '../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'franchise',
})

export default {
  name: 'Franchise',
  components: {
    Builder,
    InsightWidget,
    SectionDefault,
    SectionHero,
    OrganismHero,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      hero: {
        variant: 'dark-parallax',
        title1: 'Франшиза',
        title2: 'Encore Fitness',
        subtitle: 'для запуска премиального lifestyle-клуба',
        subtitleClass: 'text-base md:-mt-1 md:text-[30px]',
        subtitleAfterHrMobile: true,
        mobileBackgroundColor: '#FFFFFF',
        breadcrumbs: c.$breadcrumbs.franchise(),
      },
      contactWidget: {
        title: 'Получить презентацию франшизы',
      },
      links: [
        {
          to: '#about',
          name: 'О франшизе',
          class: 'active',
        },
        {
          to: '#numbers',
          name: 'Цифры',
        },
        {
          to: '#peculiarities',
          name: 'Особенности',
        },
        {
          to: '#services',
          name: 'Услуги',
        },
        {
          to: '#contacts',
          name: 'Контакты',
        },
      ],
    }
  },
}
</script>

<style lang="postcss" scoped>
.franchise-hero {
  @apply !min-h-[400px] md:!min-h-[calc(100svh-120px)];
}

.franchise-hero :deep(.hero-shadow) {
  @apply -md:!border-b-0;
}

.franchise-hero :deep(.hero-wrap > .absolute.z-10) {
  @apply -md:!bottom-2 md:!bottom-2 md:!right-2 md:!left-auto md:!pl-0 md:!h-auto;
}

.franchise-hero :deep(.hero-wrap > .absolute.z-10 > div) {
  @apply -md:!pb-0 md:!pb-0 md:!block md:!h-auto;
}

.franchise-hero :deep(.hero-wrap > .absolute.z-10 > div > div) {
  @apply md:!col-auto md:!w-auto md:!flex-none;
}

.franchise-hero__content {
  @apply !min-h-[400px] md:!min-h-[calc(100svh-120px)];
}
</style>
